export const RegAgent = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_293_24151)">
      <path
        d="M12.8328 0L9.33275 0.00116667C8.69108 0.00116667 8.16608 0.52675 8.16667 1.16842L8.16783 5.70208C8.16783 6.20258 8.72142 6.50592 9.14317 6.23583L10.5747 5.25058H14V1.16667C14 0.522083 13.4773 0 12.8328 0ZM11.3563 3.8885C11.0886 4.165 10.6447 4.16325 10.3792 3.88442L9.191 2.62908L10.0001 1.7885L10.8727 2.71075L12.3562 1.176L13.1717 2.01017L11.3557 3.88908L11.3563 3.8885ZM4.37442 7C6.14308 7 7.58275 5.56092 7.58275 3.79167C7.58275 2.02242 6.14367 0.583333 4.375 0.583333C2.60633 0.583333 1.16667 2.02242 1.16667 3.79167C1.16667 5.56092 2.60575 7 4.37442 7ZM4.37442 1.75C5.50025 1.75 6.41608 2.66583 6.41608 3.79167C6.41608 4.9175 5.50025 5.83333 4.37442 5.83333C3.24858 5.83333 2.33275 4.9175 2.33275 3.79167C2.33275 2.66583 3.24858 1.75 4.37442 1.75ZM8.74942 10.7917V14H7.58275V10.7917C7.58275 9.98783 6.92883 9.33333 6.12442 9.33333H2.62442C1.82 9.33333 1.16608 9.98783 1.16608 10.7917V14H0V10.7917C0 9.34442 1.17775 8.16667 2.625 8.16667H6.125C7.57225 8.16667 8.75 9.34442 8.75 10.7917H8.74942Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24151">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
